import { Table, Typography } from 'antd';
import type { TrackPoint } from '../maps/types';
import { formatTrackTimestamp } from '../utils/formatters';

const { Text } = Typography;

export interface GpsTrackHistoryListProps {
  points: TrackPoint[];
  onSelectPoint?: (point: TrackPoint, index: number) => void;
}

function GpsTrackHistoryList({ points, onSelectPoint }: GpsTrackHistoryListProps) {
  if (points.length === 0) return null;

  return (
    <div style={{ marginTop: 16 }}>
      <Text strong style={{ display: 'block', marginBottom: 8 }}>
        GPS history ({points.length} points)
      </Text>
      <Table
        size="small"
        rowKey={(_, index) => String(index)}
        pagination={{ pageSize: 8, showSizeChanger: points.length > 20 }}
        dataSource={points.map((point, index) => ({ ...point, index }))}
        onRow={(record, index) => ({
          onClick: () => onSelectPoint?.(record, index ?? 0),
          style: { cursor: onSelectPoint ? 'pointer' : 'default' },
        })}
        columns={[
          {
            title: '#',
            width: 48,
            render: (_, __, index) => index + 1,
          },
          {
            title: 'Acquired at',
            dataIndex: 'timestamp',
            render: (value: string) => formatTrackTimestamp(value),
          },
          {
            title: 'Coordinates',
            render: (_, row) => (
              <Text type="secondary" style={{ fontFamily: 'monospace', fontSize: 12 }}>
                {row.lat.toFixed(5)}, {row.lng.toFixed(5)}
              </Text>
            ),
          },
        ]}
      />
    </div>
  );
}

export default GpsTrackHistoryList;
